/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_spineliner': {
    width: 32,
    height: 30,
    viewBox: '0 0 32 30',
    data: '<path pid="0" d="M15.366 12.616l2.122 2.121m-2.122-2.12a2 2 0 0 1-2.828 0C6.528 6.605 4.406 10.14.87 6.605L6.527.949l8.84 8.839a2 2 0 0 1 0 2.828zm2.122 2.12a4 4 0 0 0 0 5.657m0-5.657a4 4 0 0 1 5.657 0m3.124-1.71A8.003 8.003 0 0 1 15.777 23.52M30.57 11.555c1.601 4.204.498 9.402-3.182 13.082-3.68 3.68-8.878 4.783-13.081 3.182"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_spineliner.js